// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__eXsOu"};